import React from 'react';

/**
 * Loading Spinner Component
 * @param {Object} props - Component props
 * @param {string} props.size - Spinner size ('sm', 'md', 'lg')
 * @param {string} props.color - Spinner color class
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.message - Loading message
 */
const LoadingSpinner = ({ 
  size = 'md', 
  color = 'border-blue-600', 
  className = '',
  message = 'Chargement...'
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div 
        className={`
          animate-spin rounded-full border-2 border-gray-200 border-t-2 
          ${sizeClasses[size]} ${color}
        `}
      />
      {message && (
        <p className="mt-2 text-sm text-gray-600">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;